module.exports = __webpack_public_path__ + "static/img/dfb.cce0ee0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dfb.jpg
// module id = /lsp
// module chunks = 36